<form [formGroup]="paymentForm" (ngSubmit)="savePayment(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-secure-payment-line me-1 font-20 text-primary"></i>
            {{paymentForm.value.id?'Update':'Add'}} Payment
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="row justify-content-center mt-4">
        <div class="col-md-4">
            <label for="date" class="form-label">Salary Date<b class="text-secondary">*</b></label>
            <input type="date" id="date" class="form-control" autocomplete="off" ngbAutofocus
             readonly   placeholder="Date" required formControlName="salaryDate">
            <div class="valid-feedback">Required!</div>
        </div>
    </div>
    <div *ngIf="salarySlip">
        <app-salary-slip [isSalarySlipVisible]="true" [salaryDate]="salaryDate"
            [salarySlip]="salarySlip"></app-salary-slip>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label for="date" class="form-label">Payment Date<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                            class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" formControlName="date"
                        [ngClass]="{'is-invalid': submitted && f.date.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.date.errors">
                        <span *ngIf="f.date.errors.required">Please select a payment Date.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="type" class="form-label">Payment Mode<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-layer'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="paymentMode"
                        placeholder="Select payment mode" [ngClass]="{'is-invalid': submitted && f.paymentMode.errors}">
                        <ng-option *ngFor=" let paymentMode of paymentModes;"
                            [value]="paymentMode">{{paymentMode}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && f.paymentMode.errors">
                        <span *ngIf="a.paymentMode.errors.required">Please select a paymentMode .</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="paymentId" class="form-label">Payment ID</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-wallet'></i></span>
                    <input type="text" class="form-control ps-1" id="account" placeholder="Enter payment ID"
                        [ngClass]="{'is-invalid': submitted && f.paymentId.errors}" formControlName="paymentId"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.paymentId.errors">
                        <span *ngIf="f.paymentId.errors.required ||f.paymentId.errors.pattern">Please enter a valid
                            paymentId..</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="remarks" class="form-label">Remarks</label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bxs-comment'></i></span>
                    <input type="text" class="form-control ps-1" id="label" placeholder="Enter payment remarks"
                        [ngClass]="{'is-invalid': submitted && f.remarks.errors}" formControlName="remarks"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.remarks.errors">
                        <span *ngIf="f.remarks.errors.required">Please enter a valid payment remarks..</span>
                        <span *ngIf="f.remarks.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i
                class="bx bx-x"></i>Close</button>
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event':inProgress?.value=='true'}">
            <ng-container *ngIf="inProgress?.value=='true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{paymentForm.value.id?'Updating...':'Saving...'}}
            </ng-container>
            <ng-container *ngIf="inProgress?.value!='true'">
                <i class="bx bx-save"></i>{{paymentForm.value.id?'Update':'Save'}}
            </ng-container>
        </button>
    </div>
</form>